/* Stylesheet */

.dropdown_item {
  margin: 16px 0px 0px 0px;

  .label {
    margin: 0px 0px 8px 16px;
    font-size: 0.875rem;
    color: var(--ion-color-text-secondary);
  }

  .item {
    display: flex;
    align-items: center;
    max-height: 42px;
    font-size: 0.875rem;
    --background: transparent;
    --color: var(--ion-color-text-secondary);

    .year {
      .icon {
        margin: 0px 12px 0px 0px;
        height: 14px;
        width: 14px;
      }
    }
  }
}

/* Media Queries */
@media screen and (min-width: 1600px) {
  .dropdown_item {
    .item {
      font-size: 1rem;
    }
  }
}
